/**============================================================
*   [Class] ブログ：バナースライダー
============================================================*/
export default class ArchiveBannerSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');
    let swiperSlideItemNum = swiperSlides.length;
    this.slidable = swiperSlideItemNum > 3;
    this.swiperSlideItemNum = swiperSlides.length * 3;

    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 'auto',
        watchOverflow: !this.slidable,
        loop: this.slidable,
        centeredSlides: true,
        loopAdditionalSlides: this.swiperSlideItemNum,
        loopPreventsSlide: true,
        loopedSlides: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        speed: 800,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        grabCursor: true,
      });
    };
    this.mySwiper = null;
    this.checkBreakpoint = () => {
      if(swiperSlideItemNum > Math.floor(this.swiperSlide.clientWidth/380)){
        //スライドつける
        this.slidable = true;
        if(this.mySwiper == null){
          document.querySelector('.p-archive-banner-slider .p-nav-swiper-pagination').classList.remove('d-none');
          document.querySelector('.p-archive-banner-slider .swiper-wrapper').classList.remove('justify-content-center');
          this.initSwiper();
        }
      }else {
        //スライドつけない
        this.slidable = false;
        document.querySelector('.p-archive-banner-slider .p-nav-swiper-pagination').classList.add('d-none');
        document.querySelector('.p-archive-banner-slider .swiper-wrapper').classList.add('justify-content-center');
        if(this.mySwiper){
          this.mySwiper.destroy(false, true);
          this.mySwiper = null;
        }
      }
    }

    //3個表示
    // @media (max-width: 1164px)
    this.mediaQueryPC1 = window.matchMedia('(max-width: 1164px)');
    this.mediaQueryPC1.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC1);

    //2個表示
    //@media (max-width: 1130px)
    this.mediaQueryPC2 = window.matchMedia('(max-width: 1130px)');
    this.mediaQueryPC2.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC2);

    //1個表示
    //@media (max-width: 808px)
    this.mediaQueryPC3 = window.matchMedia('(max-width: 808px)');
    this.mediaQueryPC3.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC3);

  }
}
